import type { DataChartStyleProps } from './datachartStyleRegistry'
import { AirQualityChartBase } from './AirQualityChartBase'

export function AirQualityChartStyle02(props: DataChartStyleProps) {
  return <AirQualityChartBase variant="gold" chartType="bar" {...props} />
}
